import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import pushNotificationsReducer from '../reducers/pushNotificationsReducer';

const configureStore = (railsProps) => (
  createStore(pushNotificationsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
